import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import JobListing from './pages/JobListing';
import JobDetail from './pages/JobDetail';
import About from './pages/About';
import Contact from './pages/Contact';
import Plans from './pages/Plans';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import HowItWorks from './pages/HowItWorks';
import AuthCallback from './pages/AuthCallback';
import { Toaster } from './components/ui/sonner';
import ErrorBoundary from './components/ErrorBoundary';

const PAINEL_URL = import.meta.env.VITE_PAINEL_URL || 'https://maisqvagas.h2k.com.br';

/** Redireciona para o painel externo (Livewire) */
function ExternalRedirect({ to }: { to: string }) {
  useEffect(() => {
    window.location.href = to;
  }, [to]);
  return null;
}

export default function App() {
  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <ErrorBoundary>
        <Routes>
        {/* Páginas públicas (front) */}
        <Route path="/" element={<Home />} />
        <Route path="/vagas" element={<JobListing />} />
        <Route path="/vaga/:id" element={<JobDetail />} />

        {/* Páginas Institucionais */}
        <Route path="/sobre" element={<About />} />
        <Route path="/contato" element={<Contact />} />
        <Route path="/planos" element={<Plans />} />
        <Route path="/como-funciona" element={<HowItWorks />} />
        <Route path="/termos" element={<Terms />} />
        <Route path="/privacidade" element={<Privacy />} />

        {/* Auth callback (sincroniza token do painel Livewire → localStorage) */}
        <Route path="/auth/callback" element={<AuthCallback />} />

        {/* Auth → redireciona para painel Livewire (domínio diferente) */}
        <Route path="/login" element={<ExternalRedirect to={`${PAINEL_URL}/login`} />} />
        <Route path="/cadastro" element={<ExternalRedirect to={`${PAINEL_URL}/cadastro`} />} />
        <Route path="/forgot-password" element={<ExternalRedirect to={`${PAINEL_URL}/forgot-password`} />} />
        <Route path="/recuperar-senha" element={<ExternalRedirect to={`${PAINEL_URL}/forgot-password`} />} />
        <Route path="/reset-password" element={<ExternalRedirect to={`${PAINEL_URL}/reset-password`} />} />
        <Route path="/verify-email" element={<ExternalRedirect to={`${PAINEL_URL}/verify-email`} />} />
        <Route path="/email/verify" element={<ExternalRedirect to={`${PAINEL_URL}/email/verify`} />} />
        <Route path="/email/verify/:id/:hash" element={<ExternalRedirect to={`${PAINEL_URL}/email/verify`} />} />
        <Route path="/email-verified" element={<ExternalRedirect to={`${PAINEL_URL}/login`} />} />

        {/* Dashboards → redireciona para painel Livewire (domínio diferente) */}
        <Route path="/empresa/*" element={<ExternalRedirect to={`${PAINEL_URL}/empresa/dashboard`} />} />
        <Route path="/candidato/*" element={<ExternalRedirect to={`${PAINEL_URL}/candidato/dashboard`} />} />
        <Route path="/admin/*" element={<ExternalRedirect to={`${PAINEL_URL}/admin/dashboard`} />} />
        </Routes>
        <Toaster />
      </ErrorBoundary>
    </Router>
  );
}
